module.exports = {
 
    // devUrl: 'http://10.6.19.203:8062',//建勇
    devUrl: 'http://192.168.240.167:8062',
    devVideoUrl: 'http://192.168.251.7',//视频播放地址
    proUrl: 'https://www.caacic.cn'
    // proUrl: 'http://192.168.251.5:8081'
}
